/* Zabi PDP Kern — gallery switch + variant-pills + bundel-tiers.
Minimale front-end logica; ATC-verwerking blijft Dawn's product-form.js. */
(function () {
function initGallery(root) {
var thumbs = root.querySelectorAll('[data-zabi-thumb]');
var mains = root.querySelectorAll('[data-zabi-main]');
var mainWrap = root.querySelector('.zabi-pdp-gallery__main');
var mq = window.matchMedia('(max-width: 749px)');
if (!mains.length) return;

var dots = root.querySelectorAll('[data-zabi-dot]');
function setActive(id) {
thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-zabi-thumb') === id); });
mains.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-zabi-main') === id); });
dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-zabi-dot') === id); });
}

thumbs.forEach(function (thumb) {
thumb.addEventListener('click', function () {
var id = thumb.getAttribute('data-zabi-thumb');
setActive(id);
// Mobiel: hoofdbeelden zijn een swipe-strip -> scroll naar de gekozen slide.
if (mq.matches && mainWrap) {
var idx = Array.prototype.findIndex.call(mains, function (m) { return m.getAttribute('data-zabi-main') === id; });
if (idx > -1) mainWrap.scrollTo({ left: idx * mainWrap.clientWidth, behavior: 'smooth' });
}
});
});

// Mobiel swipen: dots/thumb volgen LIVE tijdens het scrollen.
if (mainWrap) {
var lastId = null;
mainWrap.addEventListener('scroll', function () {
if (!mq.matches) return;
var idx = Math.round(mainWrap.scrollLeft / mainWrap.clientWidth);
var m = mains[Math.max(0, Math.min(idx, mains.length - 1))];
if (!m) return;
var id = m.getAttribute('data-zabi-main');
if (id !== lastId) { lastId = id; setActive(id); }
}, { passive: true });
}
}

function initBuybox(root) {
var buybox = root.querySelector('[data-zabi-buybox]');
if (!buybox) return;

// --- Variant data ---
var variants = [];
var dataEl = buybox.querySelector('[data-zabi-variants]');
if (dataEl) {
try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
}

var idInput = buybox.querySelector('[data-zabi-variant-id]');
var qtyInput = buybox.querySelector('[data-zabi-qty]');
var priceCurrent = buybox.querySelector('[data-zabi-price-current]');
var priceCompare = buybox.querySelector('[data-zabi-price-compare]');
var save = buybox.querySelector('[data-zabi-save]');
var unitPrice = buybox.querySelector('[data-zabi-unit-price]');
var atc = buybox.querySelector('[data-zabi-atc]');
var atcText = buybox.querySelector('[data-zabi-atc-text]');
var atcPrice = buybox.querySelector('[data-zabi-atc-price]');
var hasTiers = buybox.getAttribute('data-zabi-has-tiers') === 'true';

// --- Variant-pills ---
var pills = buybox.querySelectorAll('[data-zabi-option-value]');
var optionCount = 0;
pills.forEach(function (p) {
var pos = parseInt(p.getAttribute('data-zabi-option-position'), 10);
if (pos > optionCount) optionCount = pos;
});

function selectedOptions() {
var sel = [];
for (var i = 1; i <= optionCount; i++) {
var active = buybox.querySelector('[data-zabi-option-position="' + i + '"].is-active');
sel.push(active ? active.getAttribute('data-zabi-option-value') : null);
}
return sel;
}

function findVariant(sel) {
for (var i = 0; i < variants.length; i++) {
var match = true;
for (var j = 0; j < sel.length; j++) {
if (sel[j] != null && variants[i].options[j] !== sel[j]) { match = false; break; }
}
if (match) return variants[i];
}
return null;
}

function applyVariant(v) {
if (!v) return;
if (idInput) {
idInput.value = v.id;
if (v.available) { idInput.removeAttribute('disabled'); }
else { idInput.setAttribute('disabled', 'disabled'); }
}
if (unitPrice) unitPrice.textContent = v.price;
// Met bundel-tiers stuurt de gekozen tier de hoofdprijs (niet de losse variant-prijs).
if (!hasTiers) {
if (priceCurrent) priceCurrent.textContent = v.price;
if (priceCompare) {
if (v.hasCompare) { priceCompare.textContent = v.compare; priceCompare.removeAttribute('hidden'); }
else { priceCompare.setAttribute('hidden', ''); }
}
if (save) {
if (v.hasCompare) { save.hidden = false; save.removeAttribute('hidden'); }
else { save.setAttribute('hidden', ''); }
}
}
// ATC prijs volgt de variant alleen wanneer er geen bundel-tiers zijn.
if (!hasTiers && atcPrice) atcPrice.textContent = v.price;
if (atc) {
if (v.available) {
atc.removeAttribute('disabled');
if (atcText) atcText.textContent = atc.getAttribute('data-label-add') || atcText.textContent;
} else {
atc.setAttribute('disabled', 'disabled');
}
}
}

if (atcText && atc) atc.setAttribute('data-label-add', atcText.textContent.trim());

pills.forEach(function (pill) {
pill.addEventListener('click', function () {
var pos = pill.getAttribute('data-zabi-option-position');
buybox.querySelectorAll('[data-zabi-option-position="' + pos + '"]').forEach(function (p) {
var on = p === pill;
p.classList.toggle('is-active', on);
p.setAttribute('aria-checked', on ? 'true' : 'false');
});
applyVariant(findVariant(selectedOptions()));
});
});

// --- Bundel-tiers ---
var tiers = buybox.querySelectorAll('[data-zabi-tier]');

// Zet quantity + hoofdprijs (+compare) + ATC-prijs op de gekozen tier.
function applyTier(tier, input) {
tiers.forEach(function (t) { t.classList.toggle('is-active', t === tier); });
if (!input) return;
input.checked = true;
var tQty = input.getAttribute('data-zabi-tier-qty') || '1';
var tPrice = input.getAttribute('data-zabi-tier-price') || '';
var tCompare = input.getAttribute('data-zabi-tier-compare') || '';
var tSave = input.getAttribute('data-zabi-tier-save') || '';
if (qtyInput) qtyInput.value = tQty;
if (tPrice) {
if (priceCurrent) priceCurrent.textContent = tPrice;
if (atcPrice) atcPrice.textContent = tPrice;
}
if (priceCompare) {
if (tCompare) { priceCompare.textContent = tCompare; priceCompare.removeAttribute('hidden'); }
else { priceCompare.setAttribute('hidden', ''); }
}
if (save) {
if (tSave) { save.textContent = tSave; save.removeAttribute('hidden'); }
else { save.setAttribute('hidden', ''); }
}
}

tiers.forEach(function (tier) {
var input = tier.querySelector('.zabi-pdp-buybox__tier-input');
tier.addEventListener('click', function () { applyTier(tier, input); });
});

// Init: synchroniseer de hoofdprijs met de standaard-gekozen tier (bv. "2 stuks").
if (hasTiers && tiers.length) {
var checked = null;
tiers.forEach(function (tier) {
var input = tier.querySelector('.zabi-pdp-buybox__tier-input');
if (input && input.checked) checked = tier;
});
if (!checked) checked = tiers[0];
applyTier(checked, checked.querySelector('.zabi-pdp-buybox__tier-input'));
}
}

/* Sticky ATC-bar: verschijnt zodra de gewone koopknop uit beeld is. */
function initSticky(root) {
var bar = root.querySelector('[data-zabi-sticky]');
var atc = root.querySelector('[data-zabi-atc]');
if (!bar || !atc || !('IntersectionObserver' in window)) return;

var stickyBtn = bar.querySelector('[data-zabi-sticky-atc]');
var stickyPrice = bar.querySelector('[data-zabi-sticky-price]');

// Prijs + beschikbaarheid live meesyncen met de hoofdknop.
var atcPrice = root.querySelector('[data-zabi-atc-price]');
var atcText = root.querySelector('[data-zabi-atc-text]');
var stickyText = bar.querySelector('[data-zabi-sticky-atc-text]');
function sync() {
if (stickyPrice && atcPrice) stickyPrice.textContent = atcPrice.textContent;
if (stickyText && atcText) stickyText.textContent = atcText.textContent.trim();
if (stickyBtn) {
if (atc.hasAttribute('disabled')) stickyBtn.setAttribute('disabled', 'disabled');
else stickyBtn.removeAttribute('disabled');
}
}
var mo = new MutationObserver(sync);
mo.observe(atc, { subtree: true, characterData: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
sync();

if (stickyBtn) {
stickyBtn.addEventListener('click', function () {
if (atc.hasAttribute('disabled')) return;
atc.click();
});
}

var io = new IntersectionObserver(function (entries) {
var visible = entries[0].isIntersecting;
bar.classList.toggle('is-visible', !visible);
bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
}, { threshold: 0 });
io.observe(atc);
}

function init() {
document.querySelectorAll('.zabi-pdp-main[data-section-id]').forEach(function (root) {
initGallery(root);
initBuybox(root);
initSticky(root);
});
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}

// Herinitialiseren in de theme-editor bij sectie-load.
document.addEventListener('shopify:section:load', function (e) {
var root = e.target.querySelector('.zabi-pdp-main[data-section-id]');
if (root) { initGallery(root); initBuybox(root); initSticky(root); }
});
})();

/* Bezorg-countdown: tijd tot de cutoff (lokale tijd), elke 30s bijgewerkt.
Ma t/m vr voor de cutoff = timer. Weekend (en vr na de cutoff) = weekendtekst.
Teksten komen uit de locales via data-t-dag / data-t-uur (zabi.pdp_main.*),
met Nederlands als terugval. */
(function () {
var el = document.querySelector('[data-zabi-countdown]');
if (!el) return;
var out = el.querySelector('[data-zabi-countdown-time]');
var textEl = out ? out.parentElement : null;
var cut = (el.getAttribute('data-cutoff') || '23:00').split(':');
var ch = parseInt(cut[0], 10) || 23;
var cm = parseInt(cut[1], 10) || 0;
function attr(name, fb) {
var v = el.getAttribute(name);
return v && v.indexOf('ranslation missing') === -1 ? v : fb;
}
var tDag = attr('data-t-dag', 'Bestel nu, [day] in huis');
var tUur = attr('data-t-uur', 'u');

function tick() {
var now = new Date();
var day = now.getDay(); // 0 = zo, 6 = za
var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), ch, cm, 0);
var nextDay = day === 0 || day === 6 || (day === 5 && now >= target);

if (nextDay) {
if (textEl) textEl.textContent = tDag.replace('[day]', 'maandag');
return;
}
var diff = Math.max(0, target - now);
var h = Math.floor(diff / 3600000);
var m = Math.floor((diff % 3600000) / 60000);
if (out) out.textContent = h + ' ' + tUur + ' ' + m + ' min';
}
tick();
setInterval(tick, 30000);
})();

/* Uitgelichte review: kies per bezoek een review en reken "x geleden" opnieuw uit. */
(function () {
var items = document.querySelectorAll('[data-zabi-fr-item]');
if (!items.length) return;

var LABELS = {
vandaag: 'vandaag',
gisteren: 'gisteren',
dagen: '__n__ dagen geleden',
vorige_week: 'vorige week',
weken: '__n__ weken geleden',
vorige_maand: 'vorige maand',
maanden: '__n__ maanden geleden',
vorig_jaar: 'vorig jaar',
jaar: '__n__ jaar geleden'
};
var labelBron = document.querySelector('[data-zabi-tijd-labels]');
if (labelBron) {
try {
var gelezen = JSON.parse(labelBron.textContent);
Object.keys(LABELS).forEach(function (k) {
if (typeof gelezen[k] === 'string' && gelezen[k]) LABELS[k] = gelezen[k];
});
} catch (e) {
/* stuk JSON: bij het Nederlands blijven */
}
}

function label(sleutel, aantal) {
return LABELS[sleutel].replace('__n__', aantal);
}

function tijdGeleden(iso) {
var d = (iso || '').split('-');
if (d.length !== 3) return '';
var nu = new Date();
var dagen = Math.round(
(Date.UTC(nu.getFullYear(), nu.getMonth(), nu.getDate()) -
Date.UTC(parseInt(d[0], 10), parseInt(d[1], 10) - 1, parseInt(d[2], 10))) / 86400000
);
if (isNaN(dagen)) return '';
if (dagen < 0) dagen = 0;
if (dagen === 0) return LABELS.vandaag;
if (dagen === 1) return LABELS.gisteren;
if (dagen < 7) return label('dagen', dagen);
if (dagen < 14) return LABELS.vorige_week;
if (dagen < 31) return label('weken', Math.floor(dagen / 7));
if (dagen < 61) return LABELS.vorige_maand;
if (dagen < 365) return label('maanden', Math.floor(dagen / 30));
if (dagen < 730) return LABELS.vorig_jaar;
return label('jaar', Math.floor(dagen / 365));
}

var hoogste = 0;
Array.prototype.forEach.call(items, function (el) {
var i = parseInt(el.getAttribute('data-zabi-fr-index'), 10) || 0;
if (i > hoogste) hoogste = i;
});
var keuze = hoogste > 0 ? Math.floor(Math.random() * (hoogste + 1)) : 0;

Array.prototype.forEach.call(items, function (el) {
var i = parseInt(el.getAttribute('data-zabi-fr-index'), 10) || 0;
el.hidden = i !== keuze;
var d = el.querySelector('[data-zabi-fr-datum]');
if (d) {
var tekst = tijdGeleden(d.getAttribute('data-zabi-fr-datum'));
if (tekst) d.textContent = tekst;
}
});
})();
